import { GetAddressQuery } from "@/generated/graphql";
import { ErrorCode } from "@/libs/errors";
import { graphql, HttpResponse } from "msw";

export const getAddressHandler = graphql.query<GetAddressQuery>(
  "getAddress",
  async ({ query, variables }) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (variables.postalCode === "1111111") {
      return HttpResponse.json({
        data: {
          addresses: [
            {
              prefectures: "東京都",
              municipality: "千代田区",
              blockBuildingName: "千代田1丁目",
            },
          ],
        },
      });
    } else if (variables.postalCode === "2222222") {
      return HttpResponse.json({
        data: {
          addresses: [
            {
              prefectures: "東京都",
              municipality: "千代田区",
              blockBuildingName: "千代田1丁目",
            },
            {
              prefectures: "東京都",
              municipality: "千代田区",
              blockBuildingName: "千代田2丁目",
            },
            {
              prefectures: "東京都",
              municipality: "千代田区",
              blockBuildingName: "千代田3丁目",
            },
          ],
        },
      });
    } else if (variables.postalCode === "8888888") {
      return HttpResponse.json({
        data: {
          addresses: null,
        },
        errors: [
          {
            extensions: {
              code: ErrorCode[ErrorCode.INTERNAL_SERVER_ERROR],
            },
          },
        ],
      });
    } else if (variables.postalCode === "9999999") {
      return HttpResponse.json(
        {
          data: {
            addresses: [],
          },
        },
        { status: 500 }
      );
    }
    return HttpResponse.json({
      data: {
        addresses: [],
      },
    });
  }
);
